export const VOICE_SOCKET_EVENTS = Object.freeze({
  JOIN_ROOM: 'join_room',
  INCOMING_CALL: 'incoming_call',
  AGENT_SIP_INVITE: 'agent_sip_invite',
  CALL_ANSWERED: 'call_answered',
  CALL_HANGUP: 'call_hangup',
  CALL_FAILED: 'call_failed'
});

export const DEFAULT_VOICE_SOCKET_EVENTS = Object.freeze([
  VOICE_SOCKET_EVENTS.INCOMING_CALL,
  VOICE_SOCKET_EVENTS.AGENT_SIP_INVITE,
  VOICE_SOCKET_EVENTS.CALL_ANSWERED,
  VOICE_SOCKET_EVENTS.CALL_HANGUP,
  VOICE_SOCKET_EVENTS.CALL_FAILED
]);

/** Agent SIP auto-answer and session confirm (ms). */
export const VOICE_AGENT_SIP_AUTO_ANSWER_TIMEOUT_MS = 45_000;

/** Delay before second RTC stats sample after call_answered (ms). */
export const VOICE_CALL_ANSWERED_RTC_STATS_DELAY_MS = 3_000;

/** Third RTC stats sample after call_answered (ms). */
export const VOICE_CALL_ANSWERED_RTC_STATS_SECOND_DELAY_MS = 6_000;

/** Remote audio kick after call_answered. */
export const VOICE_REMOTE_AUDIO_PLAYBACK_AFTER_ANSWER = Object.freeze({
  attempts: 30,
  intervalMs: 1_000
});
